import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import Container from '../../../Container/Container';
import styles from './TabSubHeader.module.scss';
import Paragraph from '../../../Typography/Paragraph/Paragraph';
const TabSubHeader = ({ data, activeElement }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.element, 'd-flex justify-content-center') }, { children: _jsx(Container, Object.assign({ className: cn(styles.container) }, { children: _jsx("div", Object.assign({ className: cn(styles.wrapper, 'd-flex') }, { children: data.map(({ name }, index) => (_jsx("div", Object.assign({ className: cn(styles.elem, name.toLowerCase() === activeElement.toLowerCase() && styles.active) }, { children: _jsx(Paragraph, { size: 2, title: name, color: name.toLowerCase() === activeElement.toLowerCase()
                            ? 'gold'
                            : 'black' }) }), index))) })) })) })));
};
export default TabSubHeader;
